import { render, staticRenderFns } from "./main_layout.vue?vue&type=template&id=5b2d2222"
import script from "./main_layout.vue?vue&type=script&lang=js"
export * from "./main_layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports